module.exports = __webpack_public_path__ + "static/media/Layout11.383d7add.png";